import ApexCharts, { ApexOptions } from "apexcharts";
import { FC, useEffect, useRef } from "react";
import {
  getCSS,
  getCSSVariableValue,
} from "../../../_metronic/assets/ts/_utils";
import { IntlShape, useIntl } from "react-intl";

type Props = {
  data: any;
};

const WeeklyReviews: FC<Props> = ({ data }) => {
  const chartRef = useRef<HTMLDivElement | null>(null);
  const intl = useIntl();
  useEffect(() => {
    if (!chartRef.current) {
      return;
    }

    const height = parseInt(getCSS(chartRef.current, "height"));

    const chart = new ApexCharts(
      chartRef.current,
      getChartOptions(height, data, intl)
    );
    if (chart) {
      chart.render();
    }

    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [chartRef]);

  return (
    <div className="card h-500px">
      <div className="card-header border-0 pt-9">
        <div className="card-title m-0">
          <span className="card-label fw-bolder fs-3 mb-1">
            {intl.formatMessage({
              id: "page.dashboard.reviews-by-week",
              defaultMessage: "Avaliações por semana",
            })}
          </span>
        </div>
      </div>

      <div className="card-body p-9">
        <div
          ref={chartRef}
          id="kt_charts_widget_1_chart"
          style={{ height: "350px" }}
        />
      </div>
    </div>
  );
};

export default WeeklyReviews;

function getDateOfISOWeek(weekYear: string) {
  var w = parseInt(weekYear.substr(5, 2));
  var y = parseInt(weekYear.substr(0, 4));
  var simple = new Date(y, 0, 1 + (w - 1) * 7);
  var dow = simple.getDay();
  var ISOweekStart = simple;
  if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay());
  else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay() - 1);
  return ISOweekStart.toLocaleDateString();
}

function getChartOptions(
  height: number,
  data: any,
  intl: IntlShape
): ApexOptions {
  // const labelColor = getCSSVariableValue('--bs-gray-500')
  // const borderColor = getCSSVariableValue('--bs-gray-200')
  // const baseColor = getCSSVariableValue('--bs-primary')
  // const secondaryColor = getCSSVariableValue('--bs-gray-300')

  return {
    series: [
      {
        name: intl.formatMessage({
          id: "chart-collected",
          defaultMessage: "Coletadas",
        }),
        data: data.map((item: any) => item.total),
      },
      {
        name: intl.formatMessage({
          id: "chart-published",
          defaultMessage: "Publicadas",
        }),
        data: data.map((item: any) => item.published),
      },
    ],
    chart: {
      fontFamily: "inherit",
      type: "area",
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "30%",
        borderRadius: 5,
      },
    },
    legend: {
      show: true,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
    },
    xaxis: {
      categories: data.map((item: any) => {
        return item._id;
      }),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          // colors: labelColor,
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          // colors: labelColor,
          fontSize: "12px",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      hover: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: "12px",
      },
      y: {
        formatter: function (val) {
          return intl.formatMessage(
            { id: "chart-review-total", defaultMessage: `${val} avaliações` },
            { total: val }
          );
        },
      },
    },
    //   colors: [baseColor, secondaryColor],
    grid: {
      // borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  };
}
